const formFields = [
  {
    key: 'supplierName',
    label: 'Supplier Name',
    isRequired: true,
  },
  {
    key: 'street',
    label: 'Street',
  },
  {
    key: 'city',
    label: 'City',
  },
  {
    key: 'state',
    label: 'State',
  },
  {
    key: 'zipCode',
    label: 'Zip Code',
  },
  {
    key: 'country',
    label: 'Country',
  },
  {
    key: 'approxAnualSpend',
    label: 'Approx. Annual Spend',
    type: 'money',
    // rules: { pattern: MONEY_REGEX },
  },
  {
    key: 'sourcingStatus',
    label: 'Sourcing Status',
    type: 'select',
    options: [
      { label: 'Single-sourced', value: 'SingleSourced' },
      { label: 'Sole-sourced', value: 'SoleSourced' },
      { label: 'Multi-sourced', value: 'MultiSourced' },
    ],
    isRequired: true,
  },
  {
    key: 'supplierRecoveryTime',
    label: 'Supplier Recovery Time',
    type: 'time',
    decoratorWord: 'months',
    // rules: { pattern: MONTH_REGEX },
  },
  {
    key: 'timeToReplaceSupplier',
    label: 'Time to Replace Supplier',
    type: 'time',
    decoratorWord: 'months',
    isRequired: true,
    // rules: { pattern: MONTH_REGEX },
  },
  {
    key: 'availableAlternatives',
    label: 'Available Alternatives',
    type: 'select',
    options: [
      { label: '0', value: '0' },
      { label: '1', value: '1' },
      { label: '2+', value: '2' },
    ],
    isRequired: true,
  },
  {
    key: 'qualifiedAlternatives',
    label: 'Qualified Alternatives',
    type: 'select',
    options: [
      { label: '0', value: '0' },
      { label: '1', value: '1' },
      { label: '2+', value: '2' },
    ],
    isRequired: true,
  },
  {
    key: 'comment',
    label: 'Comment',
    type: 'textArea',
    isRequired: false,
  },
];

export { formFields };
